
import { AbilityBuilder, Ability } from '@casl/ability'

export const AppAbility = Ability

const defineRulesFor = (role, permissions = {}) => {
  const { can, rules } = new AbilityBuilder(AppAbility)

  if (role === 'god') {
    can('manage', 'all')
  } else {
    Object.keys(permissions).forEach(permission => {
      if (permissions[permission] === 'true') {
        can('read', permission)
        can('manage', permission) // add more granular control if needed
      }
    })
  }

  return rules
}

export const buildAbilityFor = (role, permissions) => {
  return new AppAbility(defineRulesFor(role, permissions), {
    detectSubjectType: object => object.type
  })
}
